<template>
  <b-badge
    :class="expenseStatusClass"
    class="expense-badge d-inline-flex m-1"
    pill
    v-if="expense"
  >
    <span class="mx-1">
      <a
        @click.prevent="showEditExpenseModal()"
        href="#"
        title="Edit expense"
        v-b-tooltip.html="{ variant: 'base' }">
        <font-awesome-icon icon="edit"/>
      </a>
    </span>
    <span class="mx-1">
      <a
        :class="{ 'disabled': !expense.invoice_url }"
        :disabled="!expense.invoice_url"
        :href="expense.invoice_url"
        target="_blank"
      >
        <font-awesome-icon icon="file-invoice"/>
      </a>
    </span>
    <span class="mx-1">
      <a
        @click.prevent="deleteItem"
        href="#"
        title="Delete expense"
        v-b-tooltip.html="{ variant: 'base' }">
        <font-awesome-icon icon="trash"/>
      </a>
    </span>
    <FinancesExpensesForm
      :bankCards="bankCards"
      :currencies="currencies"
      :dataProps="form"
      :edit="true"
      :expensesCategories="expensesCategories"
      :expensesStatuses="expensesStatuses"
      :isLoading="loading"
      :modal="true"
      :ownBankDetails="ownBankDetails"
      :projects="getProjects"
      :show-preloader="true"
      :users="getAllUsers"
      @submit="edit"
      v-if="showForm"
      v-model="showForm"
    />
  </b-badge>
</template>
<script>
  import {cloneDeep} from 'lodash'
  import {mapActions} from 'vuex'
  import FinancesExpensesForm from '../components/forms/FinancesExpensesForm'
  import ExpenseForm from '../mixins/ExpenseForm'

  export default {
  name: 'ExpensesLinks',
  mixins: [ ExpenseForm ],
  components: {
    FinancesExpensesForm
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      expense: null,
      loading: false,
      showForm: false,
      form: {}
    }
  },
  watch: {
    'item': {
      deep: true,
      immediate: true,
      handler (item) {
        this.expense = item
      }
    }
  },
  computed: {
    expenseStatusClass () {
      if (this.expense.expenses_status.name === 'new') {
        return 'status-new'
      } else if (this.expense.expenses_status.name === 'invoice_received') {
        return 'status-invoice_received'
      } else if (this.expense.expenses_status.name === 'paid') {
        return 'status-paid'
      }
      return ''
    }
  },
  methods: {
    ...mapActions({
      setIsModalLoading: 'finances/setIsModalLoading'
    }),
    edit (data) {
      this.loading = true
      const params = this.prepareDataForEditAndCreateRequest(data)
      this.$api.expenses.updateExpenses(this.expense.id, params)
        .then(({ data, status }) => {
          this.$snotify.success(
            'Expense successfully saved',
            'Success',
            this.$store.state.snotify
          )

          this.form = {}
          this.hideEditExpenseModal()
          this.expense = cloneDeep(data)
          this.$emit('savedExpense', { data: this.expense, status })
          this.$emit('reloadExpenses')
        })
        .catch(error => {
          const errors = Object.values(error.response.data.errors)
          for (var i = 0; i < errors.length; i++) {
            this.$snotify.error(
              errors[i][0],
              'Error',
              this.$store.state.snotify
            )
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    showEditExpenseModal () {
      this.showForm = true
      this.form = cloneDeep(this.expense)
    },
    hideEditExpenseModal () {
      this.showForm = false
      this.form = {}
      this.setIsModalLoading(false)
    },
    async deleteItem () {
      const confirm = await this.$root.$confirm.open(
        'Delete',
        'Are you sure you want to delete the expenses?'
      )
      if (!confirm) return
      this.loading = true

      this.$api.expenses.removeExpenses(this.expense.id)
        .then(() => {
          this.$snotify.success(
            'Expense successfully deleted',
            'Success',
            this.$store.state.snotify
          )
        })
        .catch(error => {
          this.errorNotifications(error)
        })
        .finally(() => {
          this.$emit('deletedExpense', { data: this.expense.id })
          this.$emit('reloadExpenses')
        })
    },
    download (url) {
      window.location.assign(url)
    }
  }
}
</script>

<style lang="scss" scoped>
  .expense-badge {
    font-size: 14px;
    padding: 5px 12px;
    background-color: #DEEBFF;
    a {
      cursor: pointer;
      margin-top: 1px;
    }
  }
  .expense-popover-text {
    font-size: 13px;
  }
  .template-link {
    text-decoration: none
  }
  .status-new{
    background-color: #faf0be;
  }
  .status-invoice_received{
    background-color: #ede742;
  }
  .status-paid{
    background-color: #deebff;
  }
  .not-paid-for-sales-report {
    border: 2px solid #f2b616;
  }
  .active-action-item {
    color: #1a237e;
  }
</style>
<style lang="scss">
  .expense-badge .dropdown .dropdown-toggle {
      width: 16px;
      height: 16px;
      .material-icons {
        line-height: 15px;
        font-size: 18px;
      }
  }
</style>
